import layout from '@/views/common/layout'
const integralRouter = [
    {
        path: '/integral',
        component: layout,
        children: [
            {
                path: 'integralCategoryList',
                component: () => import('@/views/integral/integralCategoryList'),
                name: 'integralCategoryList',
                meta: { title: '分类维护', icon: '', affix: true }
            },
            {
                path: 'integralBrandList',
                component: () => import('@/views/integral/integralBrandList'),
                name: 'integralBrandList',
                meta: { title: '品牌管理', icon: '', affix: true }
            },
            {
                path: 'integralOperate',
                component: () => import('@/views/integral/integralOperate'),
                name: 'integralOperate',
                meta: { title: '运营策略管理', icon: '', affix: true }
            },
            {
                path: 'integralGoodsList',
                component: () => import('@/views//integral/integralGoodsList'),
                name: 'integralGoodsList',
                meta: { title: '积分商品', icon: '', affix: true }
            },
            {
                path: 'integralAddGoods',
                component: () => import('@/views/integral/integralAddGoods'),
                name: 'integralAddGoods',
                meta: { title: '积分商品维护', icon: '', affix: true }
            },
            {
                path: 'integralGoodsDetail',
                component: () => import('@/views/integral/integralGoodsDetail'),
                name: 'integralGoodsDetail',
                meta: { title: '积分商品详情', icon: '', affix: true }
            },
            {
                path: 'integralGoodsRank',
                component: () => import('@/views/integral/integralGoodsRanking'),
                name: 'integralGoodsRank',
                meta: { title: '商品兑换排行榜', icon: '', affix: true }
            },
            {
                path: 'integralCategoryAttrList',
                component: () => import('@/views/integral/integralCategoryAttrList'),
                name: 'integralCategoryAttrList',
                meta: { title: '分类维护', icon: '', affix: true }
            },
            {
                path: 'integralBooth',
                component: () => import('@/views/integral/integralBooth'),
                name: 'integralBooth',
                meta: { title: '积分商品展位管理', icon: '', affix: true }
            },
            {
                path: 'integralBoothEdit',
                component: () => import('@/views/integral/integralBoothEdit'),
                name: 'integralBoothEdit',
                meta: { title: '展位上架商品', icon: '', affix: true }
            },
        ]
    }
]

export default integralRouter


// WEBPACK FOOTER //
// ./src/router/modules/integralRouter.js